import { UNI_CARD_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../fabrics/createDisplayName";

export const createDisplayNameForUniCardElement = createDisplayName(
    UNI_CARD_DISPLAY_NAME,
);
